import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

export function Section({
  eyebrow, title, subtitle, children, className, id,
}: {
  eyebrow?: string;
  title?: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <section id={id} className={cn("py-20 md:py-28", className)}>
      <div className="container-x">
        {(eyebrow || title) && (
          <div className="mb-12 max-w-3xl">
            {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
            {title && <h2 className="display-lg text-silver-50">{title}</h2>}
            {subtitle && <p className="mt-4 text-silver-200 text-lg leading-relaxed">{subtitle}</p>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
